<!--
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-05-13 14:59:29
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-10 18:09:38
 -->
<template>
  <div class="noData">
    <img class="img"
      src="./images/noData.png">
    <span class="text">{{ text }}</span>
  </div>
</template>
<script>
export default {
  name: 'NoData',
  props: {
    text: {
      type: String,
      default: '暂无内容'
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="less" scoped>
.noData {
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: PingFang-SC-Medium, PingFang-SC;
  .img {
    width: 295px;
    height: 183px;
    margin-bottom: 18px;
  }
  .text {
    height: 20px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(116, 118, 125, 1);
    line-height: 20px;
  }
}
</style>
